import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { Config } from "../Utils/Config";
import { NumericFormat } from 'react-number-format';
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
export const SpanMessage = (type) => {
  return <div className="no-data">There are no {type} in this market.</div>;
};

export const renderAsserDataBasedOnTypeId = (typeId, obj) => {

  let htmlData = <>NO DATA</>;

  switch (typeId) {
    case 11:
      case 12:
      htmlData = renderDevlopmentAndForSaleBody(obj);
      break;

    case 13:
      htmlData = renderHousingBody(obj);
      break;

    case 14:
      case 15:
      htmlData = renderNationalAndStateBody(obj);
      break;

    case 16:
      htmlData = renderDevlopmentAndForSaleBody(obj);
      break;
    case 21:
      htmlData = renderDevlopmentAndForSaleBody(obj);
      break;

    default:
      break;
  }

  return htmlData;
};

const renderDevlopmentAndForSaleBody = (obj) => {

  const address = (obj.address ? obj.address +
    ", " : "") +
    ((obj.city ? obj.city +
      ", " : "") +
      (obj.statename ? obj.statename +
        " " : "")) +
    (obj.zipcode ? obj.zipcode : "");
  
  return (
    <div> 
    <table className={"map-table other-mapview" + (!address ? "mb-0" : "")} style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td><b>{obj.name || ""}</b><p className="mb-0">{address}</p></td>
              </tr>
            </tbody>
          </table>
    </div>
  )
};

const renderHousingBody = (obj) => {
  let priceMin = "";
  let priceMax = "";

  if (obj.pricerange?.length > 0) {
    let priceRange = JSON.parse(new Array(obj.pricerange));
    priceMin = priceRange[0];
    priceMax = priceRange[1];
  }
  return (
    <div className="housing-div"> 
      <table className="map-table other-mapview" style={{ width: "100%" }}>
                  <tr>
                    <td><b>{obj.name ?? ""}</b></td>
                  </tr>
                  <tr>
                    <td><p className="mb-0">Estimated no. of houses: {obj.estimatednoofhouses||"N/A"}</p></td>
                  </tr>
                  <tr>
                  <td><p className="mb-0">Price range: {priceMin && priceMax ? ( <>{Config.Currency}<NumericFormat value={priceMin} displayType="text" thousandSeparator={true} /> - {Config.Currency}<NumericFormat value={priceMax} displayType="text" thousandSeparator={true} /></>) : ( "N/A")}</p></td>

                  </tr>
                  <tr>
                    <td><p className="mb-0">Builders: {obj.buildernames || "N/A"}</p></td>
                  </tr>
                  <tr>
                    <td><p className="mb-0">Family types: {obj.familytypes || "N/A"}</p></td>
                  </tr>
                </table>
    </div>
  ) 
};

const renderNationalAndStateBody = (obj) => {

  const address = [obj.address, obj.city, obj.statename, obj.zipcode , obj.countryname]
  .filter(Boolean) // removes null, undefined, empty string, etc.
  .join(', ');
  let parkLink = (<>{obj.parklink ? <a href={obj.parklink} target="_blank">{obj.parklink}</a> : "" }</>);

  return (
    <div>
    <table className="map-table other-mapview" style={{ width: "100%" }}>
      <tr>
        <td> <b>{obj.name ?? ""}</b></td>
      </tr>
      <tr>
        <td><p className="mb-0"> {address} </p></td>
      </tr> 
      <tr>
        <td><p className="mb-0">{parkLink}</p></td>
      </tr>
      <tr>
        <td><p className="mb-0">Entrance Fees: {obj.entrancefees || "N/A"}</p> </td>
      </tr>
      <tr>
        <td><p className="mb-0">Hours: {obj.hours || "N/A"}</p></td>
      </tr>
    </table>
  </div >
  )
};

const renderMarinasBoday = (obj) => {
  return <> Marina </>;
};

//HubspotForm Added
export const HubSpotForm = ({ contactUsOpen, setContactUsOpen }) => {
  useEffect(() => {
    if (!contactUsOpen) {
      return;
    }
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    script.async = true;

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "4297816",
          formId: "60a8fed9-6875-492e-bb90-b57aa24b422e",
          target: "#hubspot-form",
        });
      }
    };
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      const formContainer = document.getElementById("hubspot-form");
      if (formContainer) {
        formContainer.innerHTML = "";
      }
    };
  }, [contactUsOpen]);

  const handleClose = () => {
    setContactUsOpen(false);
  };

  return (
    <Dialog
      open={contactUsOpen}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Contact us
        <IconButton
          onClick={handleClose}
          aria-label="close"
          size="small"
        >
          <FontAwesomeIcon icon={faXmark} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div id="hubspot-form"></div>
      </DialogContent>
    </Dialog>
  );
};